import { useAuthStore } from '@/stores/auth-store';

/**
 * True when OptiSigns-branded affordances must be HIDDEN for this account — i.e. white-label
 * (`brandingData.isWhiteLabel`, driven by the `VITE_IS_WHITE_LABEL` build flag) OR the account
 * explicitly set `removeOptiSignsBranding`. Use to gate OptiSigns promo/help links
 * (`links.optisigns.com` "Learn More" etc.) and OptiSigns wordmark/"Powered by" copy in the
 * logged-in portal.
 *
 * Keep FUNCTIONAL OptiSigns links (player downloads in the Pair dialog) regardless — those are
 * how a customer actually gets the player binary, not branding.
 *
 * Companion to the auth-store branding resolver and doc
 * claude-dev/.../12-white-label-show-hide-checklist.md.
 */
export function useHideOptiSignsBranding(): boolean {
  // AND, not OR (scio1 compound `!isWhiteLabel || (isWhiteLabel && !removeOptiSignsBranding)`):
  //  - standard build (isWhiteLabel=false) → never hide (OptiSigns' own portal);
  //  - white-label build (isWhiteLabel=true) → reduces to the removeOptiSignsBranding checkbox,
  //    so it is togglable per account.
  return useAuthStore(
    (s) =>
      !!s.company?.brandingData?.isWhiteLabel && !!s.company?.brandingData?.removeOptiSignsBranding,
  );
}
